/* ============================================
   AGENTS.JSX - SUPER SMOOTH ANIMATION
   ✅ Smooth rotation without jerks
   ✅ Pause on hover/click
   ✅ Resume automatically
   ============================================ */

import React, { useState, useEffect, useRef, useContext } from 'react';
import { ChevronDown } from 'lucide-react';
import '../../../../assets/css/Buyer/Home/agents.css';
import axios from 'axios';
import AppContext from 'context/AppContext';

const HomeAgents = () => {
  const {baseUrl,baseUrlForFiles,authToken}=useContext(AppContext);
  const [positions, setPositions] = useState([0, 1, 2]);
  const [isPaused, setIsPaused] = useState(false); // ✅ Pause state
  const intervalRef = useRef(null);

  const [agents, setAgents] = useState([]);


   const viewHomeBusinessDetails = () => {
    axios.get(`${baseUrl}/buyer/homekyc/viewHomeBusinessDetails`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
           setAgents(response.data.agents);
        }
      }).catch((error) => {
        console.log(error);

      })

  }
 useEffect(()=>{
  viewHomeBusinessDetails();
 },[])
 
  const totalAgents = agents.length;

  /* ========================================
     ✅ SMOOTH AUTO-ROTATE with Pause Control
     ======================================== */
  useEffect(() => {
    const startInterval = () => {
      intervalRef.current = setInterval(() => {
        if (!isPaused) {
          rotatePositions();
        }
      }, 3500); // ✅ Slightly longer for smoother feel
    };

    startInterval();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused]);

  /* ========================================
     🔄 Smooth Position Rotation
     ======================================== */
  const rotatePositions = () => {
    setPositions(prev => [prev[2], prev[0], prev[1]]);
  };

  /* ========================================
     ⏸️ Pause on Hover
     ======================================== */
  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  /* ========================================
     🖱️ Manual Click - Rotate & Pause briefly
     ======================================== */
  const handleImageClick = () => {
    setIsPaused(true);
    rotatePositions();
    
    // Resume after 2 seconds
    setTimeout(() => {
      setIsPaused(false);
    }, 2000);
  };

  const handleArrowClick = () => {
    setIsPaused(true);
    rotatePositions();
    
    // Resume after 2 seconds
    setTimeout(() => {
      setIsPaused(false);
    }, 2000);
  };

  // Get current center agent
  const centerAgentIndex = positions[1];
  const currentAgent = agents[centerAgentIndex];

  return (
    <section className="agents-section">
      <div className="agents-container">
        <div className="agents-header">
          <h2 className="agents-heading">Expert Agents</h2>
          <span className="agents-counter">{centerAgentIndex + 1}/{totalAgents}</span>
        </div>

        <div className="agents-content">
          {/* LEFT - Agent Info */}
          <div className="agents-left-text">
            <div className="agents-info">
              <h3 className="agent-name">{currentAgent?.businessName}</h3>
              <p className="agent-role">{currentAgent?.licenseNumber}</p>
              <p className="agent-description">Specializes in high-yield investment opportunities with a client-first approach.</p>
            </div>
          </div>

          {/* CENTER - Images with Hover Pause */}
          <div 
            className="agents-center-images"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <div className="agents-images-section">
              <div className="images-wrapper">
                {agents.map((agent, agentIndex) => {
                  const positionIndex = positions.indexOf(agentIndex);
                  return (
                    <div 
                      key={agent.id}
                      className={`image-box image-box-pos-${positionIndex} ${isPaused ? 'paused' : ''}`}
                      onClick={handleImageClick}
                    >
                      <img 
                        src={`${baseUrlForFiles}${agent.exseller?.profileImage}`}
                        alt={agent.exseller?.fullName}
                        className="agent-image"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* RIGHT - Details & Arrow */}
          <div className="ag-right-details">
            <div className="ag-details-box">
              <div className="ag-detail-item">
                <p className="ag-detail-label">EXPERIENCE</p>
                <p className="ag-detail-value">{currentAgent?.experience}</p>
              </div>
              <div className="ag-detail-item">
                <p className="ag-detail-label">LOCATION</p>
                <p className="ag-detail-value">{currentAgent?.businessAddress}</p>
              </div>
            </div>

            <button 
              className="arrow-button"
              onClick={handleArrowClick}
              aria-label="Next agent"
            >
              <ChevronDown size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAgents;